import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary';

export const parseFinancialRowsOrderLayout = (financialRows: TwinDictionary[], financialRowTypesDict: TwinDictionary) => {
    const parsedFinancialRows: TwinDictionary[] = []
    let absoluteIndex = 0
    for (const element of financialRows) {
        if (financialRowTypesDict[element?.financialRowType]) {
            element.absoluteIndex = absoluteIndex
            parsedFinancialRows.push(element)
        }
        absoluteIndex++
    }
    return parsedFinancialRows
}